import { BaseButton, BaseButtonProps } from "@towersystems/roam-common-native";
import React from "react";
import { StyleProp, TextStyle } from "react-native";
import { Colors, Text, View } from "react-native-ui-lib";
import { QuickKeyTileButton } from "./components";

export type QuickKeyProps = BaseButtonProps & {
  label?: string;
  labelColor?: string;
  labelComponent?: React.ReactNode;
  labelStyle?: StyleProp<TextStyle>;
  subtitle?: string;
  subtitleStyle?: StyleProp<TextStyle>;
  subtitleComponent?: React.ReactNode;
  iconPrimary?: React.ReactNode;
  iconSecondary?: React.ReactNode;
  backgroundImage?: string;
  isModifier?: boolean;
  canTriggerEdit?: boolean;
  selected?: boolean;
  iconImageUrl?: string;
};

const MAX_LINES = 3;

export const QuickKey = React.forwardRef<QuickKeyProps, any>(
  (
    {
      label,
      labelStyle,
      subtitle,
      subtitleStyle,
      subtitleComponent,
      style,
      iconPrimary,
      iconSecondary,
      isDestructive,
      backgroundColor,
      backgroundImage,
      isAction,
      isModifier,
      disabled,
      labelComponent,
      canTriggerEdit = true,
      selected,
      onLongPress,
      color,
      iconImageUrl,
      labelColor,
      ...rest
    },
    ref
  ) => {
    const secondaryColor = backgroundColor ? Colors.white : Colors.text;
    const normalizedColor = labelColor || color || secondaryColor;

    let textStyles = {
      color: normalizedColor,
    };

    if (isDestructive || isAction || isModifier) {
      textStyles = {
        color: normalizedColor,
      };
    }

    if (disabled) {
      textStyles.color = normalizedColor;
    }

    const labelMarkup = labelComponent ? (
      labelComponent
    ) : label ? (
      <Text
        numberOfLines={MAX_LINES}
        style={[
          {
            ...textStyles,
            fontSize: 18,
            fontWeight: "bold",
            backfaceVisibility: "hidden",
            color: labelColor || normalizedColor,
          },
          labelStyle,
        ]}
      >
        {label}
      </Text>
    ) : undefined;

    const subtitleMarkup = subtitleComponent ? (
      subtitleComponent
    ) : subtitle ? (
      <Text
        numberOfLines={MAX_LINES}
        style={[
          { ...textStyles, opacity: "0.8", fontSize: 16 },
          subtitleStyle,
          disabled && { opacity: 0.6, color: normalizedColor },
        ]}
      >
        {subtitle}
      </Text>
    ) : undefined;

    const labelcontainerMarkup =
      labelMarkup || subtitleMarkup ? (
        <View style={{ opacity: 0.8 }}>
          {labelMarkup}
          {subtitleMarkup}
        </View>
      ) : undefined;

    const iconPrimaryMarkup = iconPrimary ? (
      <View flex style={{ alignSelf: "flex-start", flexDirection: "row" }}>
        {iconPrimary}
      </View>
    ) : undefined;

    const iconSecondaryMarkup = iconSecondary ? (
      <View
        flex
        style={{
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        {iconSecondary}
      </View>
    ) : undefined;

    let styles = [];

    styles.push({
      backgroundColor: backgroundColor
        ? backgroundColor
        : Colors.quickKeyBackground,
    });

    if (isDestructive) {
      styles.push({ backgroundColor: Colors.quickKeyDestruction });
    }

    if (isAction) {
      styles.push({ backgroundColor: Colors.quickKeyAction });
    }

    if (disabled) {
      styles.push({ backgroundColor: Colors.quickKeyBackground });
    }

    return (
      <QuickKeyTileButton
        {...rest}
        ref={ref}
        disabled={disabled}
        fullWidth
        onLongPress={onLongPress}
        style={[
          { height: 165, alignItems: "flex-end", overflow: "hidden" },
          ...styles,
          style,
          selected && { borderWidth: 5 },
        ]}
        backgroundImage={backgroundImage}
        iconImageUrl={iconImageUrl}
      >
        <View
          flex
          style={{
            justifyContent: "space-between",
            height: "100%",
            width: "100%",
          }}
        >
          <View
            flex
            style={{
              justifyContent: "space-between",
              height: "100%",
              width: "100%",
            }}
          >
            <View flex style={{ flexDirection: "row" }}>
              {iconPrimaryMarkup}
              {iconSecondaryMarkup}
            </View>
            <View>{labelcontainerMarkup}</View>
          </View>
        </View>
      </QuickKeyTileButton>
    );
  }
);
